import Link from "next/link";

import {
  InstagramFilled,
  LinkedinFilled,
  TwitterSquareFilled,
  YoutubeFilled,
} from "@ant-design/icons";
import { type VariantProps, tv } from "tailwind-variants";

// Revalidate YEAR every 24 hours
export const revalidate = 60 * 60 * 24;

const YEAR = new Date().getFullYear();

const footerVariants = tv({
  base: "z-10 flex w-full flex-col justify-end gap-4 py-4 sm:hidden sm:flex-row",
  variants: {
    type: {
      Talento: "bg-lilac-geode-1000",
      Lead: "bg-brand-dark",
    },
  },
  defaultVariants: {
    type: "Talento",
  },
});

type FooterVariantProps = VariantProps<typeof footerVariants>;

export default function Footer({ type }: FooterVariantProps) {
  return (
    <footer className={footerVariants({ type })}>
      <div className="flex flex-col items-center gap-4 px-[5.75rem] sm:items-end sm:pr-12">
        <div className="flex gap-4 text-aubergine-perl-600">
          <Link
            href="https://www.instagram.com/harpiodigital/"
            target="_blank"
            rel="noopener external"
            className="text-4xl"
            aria-label="Perfil da Harpio no Instagram"
          >
            <InstagramFilled className="text-dr-white-600" />
          </Link>
          <Link
            href="https://www.linkedin.com/company/harpiodigital/"
            target="_blank"
            rel="noopener external"
            className="text-4xl"
            aria-label="Página da Harpio no Linkedin"
          >
            <LinkedinFilled className="text-dr-white-600" />
          </Link>
          <Link
            href="https://twitter.com/harpiodigital"
            target="_blank"
            rel="noopener external"
            className="text-4xl"
            aria-label="Perfil da Harpio no Twitter"
          >
            <TwitterSquareFilled className="text-dr-white-600" />
          </Link>
          <Link
            href="https://www.youtube.com/@harpio4423"
            target="_blank"
            rel="noopener external"
            className="text-4xl"
            aria-label="Canal da Harpio no Youtube"
          >
            <YoutubeFilled className="text-dr-white-600" />
          </Link>
        </div>
        <div className="flex flex-col gap-1 text-dr-white-600 sm:flex-row">
          <p className="text-center text-sm/6">Powered by Harpio {YEAR}.</p>
          <p className="text-center text-sm/6">Todos os direitos reservados</p>
        </div>
      </div>
    </footer>
  );
}
